import { faFileLines } from "@fortawesome/free-solid-svg-icons/faFileLines";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { DataFormatoEN } from "app/types/DataFormatoEN";
import { DataFormatoPT } from "app/types/DataFormatoPT";
import { FiltroPesquisaClientes } from "app/types/cliente/FiltroPesquisaClientes";
import clsx from "clsx";
import { useFormik } from "formik";
import globalMU from "globalMU";
import React from "react";
import { InputData } from "../inputs/InputData";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";

export type UnificacaoDeOrcamentosFiltroPesquisa = {
  ClienteSelecionado?: FiltroPesquisaClientes
  DataInicial?: DataFormatoPT
  DataFinal?: DataFormatoPT
  NumeroPagina?: number;
  TamanhoPagina?: number;
}

const estiloInputs = require('../../estilos/inputs.module.scss').default
const estiloFormulario = require('../../estilos/formulario.module.scss').default
const estiloBotoes = require('../../estilos/botoes.module.scss').default

export type UnificacaoDeOrcamentosProps = {
  colorBackgroundSelecionada: string;
  colorTextoSelecionada: string;
  filtro: UnificacaoDeOrcamentosFiltroPesquisa
  listaOrcamentos: PagedMessageResponse<OrcamentoUnificacao>
  orcamentosSelecionados: number[]
  totalRegistros: number
  processandoUnificacao?: boolean
  onPesquisarCliente: () => void
  onExcluirClienteSelecionado: () => void
  onPesquisarOrcamentosParaUnificacao: (values) => void
  onConsultarOrcamento: (numeroPedido: number) => void
  onProcessarUnificacaoOrcamentos: () => void
  onSelecionarTodos: () => void
  onToggleOrcamentoSelecionado: (NumeroPedido: number) => void
  onChangeDataInicial: (data: string) => void
  onChangeDataFinal: (data: string) => void
  onAlteradoPagina: (numeroPagina: number) => void
}

export type OrcamentoUnificacao = {
  TotalRecords: number,
  NumeroPedido: number,
  CodigoFilial: string,
  DataPedido: DataFormatoEN,
  NomeVendedor: string,
  SituacaoVenda: number,
  DescricaoSituacaoVenda: string,
  ValorPedido: number,
  CodigoSituacaoConferencia: string,
  OidFormaDePagar: number,
  Tpo: string,
  OidRevenda: number,
  TiposDocumentos: string,
  TemFilialTransferencia: boolean,
  TemFilialRetiradaDiferente: boolean,
}


export const UnificacaoDeOrcamentos = (props: UnificacaoDeOrcamentosProps) => { // 427169

  const acaoSubmit = (values) => {
    props.onPesquisarOrcamentosParaUnificacao(values)
  }

  const formik = useFormik({
    initialValues: {
      clienteSelecionadoFiltro: props.filtro.ClienteSelecionado ?? {},
      dataInicialFiltro: props.filtro.DataInicial,
      dataFinalFiltro: props.filtro.DataFinal
    },
    onSubmit: acaoSubmit,
    enableReinitialize: true,
    //     validate: (values) => {


    //       const mensagemObrigatorio = (campo) => `O campo "${campo}" é obrigatório.`
    //       const mensagemDataMenor = (campo1: string, campo2: string) => `O campo  "${campo1}" não pode ser maior do que a "${campo2}".`

    //       return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
    //         clienteSelecionadoFiltro: globalMU.isNullOrEmpty(values.clienteSelecionadoFiltro.codigoClienteSelecionado) ? mensagemObrigatorio("Cliente") : null,
    //         dataInicialFiltro: globalMU.isNullOrEmpty(values.dataInicialFiltro) ? mensagemObrigatorio("Data Inicial") : 
    //                   !globalMU.isNullOrEmpty(values.dataFinalFiltro) && globalMU.formatDate(values.dataInicialFiltro) > globalMU.formatDate(values.dataFinalFiltro) ? mensagemDataMenor("Data Inicial", "Data Final") : undefined ,
    //         dataFinalFiltro: globalMU.isNullOrEmpty(values.dataFinalFiltro) ? mensagemObrigatorio("Data Final") : 
    //                   !globalMU.isNullOrEmpty(values.dataFinalFiltro) && globalMU.formatDate(values.dataFinalFiltro) < globalMU.formatDate(values.dataInicialFiltro) ? mensagemDataMenor("Data Inicial", "Data Final") : undefined ,


    //       } as FormikErrors<UnificacaoDeOrcamentosFiltroPesquisa>) 
    //     }
  });

  const formPesquisar = () => {

    const campoCliente = <>
      <label className={estiloInputs.labelObrigatorio} >Cliente</label>
      <div>
        <input
          id="UnificacaoDeOrcamentos_Cliente_Input"
          style={{ width: "440px" }}
          type="text"
          value={formik.values?.clienteSelecionadoFiltro.Nome ?? ""}
          readOnly
          disabled // sempre fica desabilitad
          title="Clique na lupa para pesquisar o cliente"
          placeholder="Clique na lupa para pesquisar"
        />
        <FontAwesomeIcon
          id="UnificacaoDeOrcamentos_Cliente_Pesquisar"
          className="_text-2xl _mx-1"
          color={"#3c8ac9"}
          icon={faSearch}
          cursor="pointer"
          onClick={() => props.onPesquisarCliente()}
        />
        <FontAwesomeIcon
          id="UnificacaoDeOrcamentos_Cliente_Excluir"
          className="_text-2xl"
          color={"#f25713"}
          icon={faTimesCircle}
          cursor="pointer"
          onClick={() => props.onExcluirClienteSelecionado()}
        />
      </div>
    </>

    const campoDataInicial = <>
      <label className={estiloInputs.labelObrigatorio}>Data Inicial</label>
      <InputData
        id="UnificacaoDeOrcamentos_DataInicial_Input"
        data={formik.values.dataInicialFiltro}
        onChange={(data) => (formik.setFieldValue("dataInicialFiltro", globalMU.converterDataFormatoENParaPT(data)), props.onChangeDataInicial(globalMU.converterDataFormatoENParaPT(data)))}
        className="_w-[200px]"

      />
    </>

    const campoDataFinal = <>
      <label className={estiloInputs.labelObrigatorio}>Data Final</label>
      <InputData
        id="UnificacaoDeOrcamentos_DataFinal_Input"
        data={formik.values.dataFinalFiltro}
        onChange={(data) => (formik.setFieldValue("dataFinalFiltro", globalMU.converterDataFormatoENParaPT(data)), props.onChangeDataFinal(globalMU.converterDataFormatoENParaPT(data)))}
        className="_w-[200px]"

      />
    </>

    const botaoPesquisarOrcamento = <button
      id="UnificacaoDeOrcamentos_BotaoPesquisarOrcamento"
      type="submit" className={clsx(`no-global-button  !_bg-[#409fff] ${estiloBotoes.botaoPrimario}`)}
      disabled={props.processandoUnificacao}
      title="Veja parâmetros: 
-Utiliza orçamento com mais vendedores controlados por setores
-Permite unificação de orçamentos somente de pedidos da filial do usuário
-Vendedor padrão para orçamento unificado"
    > Pesquisar
    </button>

    const checkboxSelecionarTodos = <div className="_flex _flex-row _items-center">
      <input
        id="unificacaoOrcamento__checkbox-selecionar-todos"
        type='checkbox'
        title='Seleciona/deseleciona todos os orçamentos'
        accessKey="0"
        //checked={props.orcamentosSelecionados.length == props.totalRegistros && props.totalRegistros > 0}
        ref={input => {
          if (input) {
            input.checked = props.orcamentosSelecionados.length == props.totalRegistros
            input.indeterminate = props.orcamentosSelecionados.length > 0 && props.orcamentosSelecionados.length != props.totalRegistros;
          }
        }}
        onChange={(e) => props.onSelecionarTodos()}
      />
    </div>

    const botaoSelecionarTodos = <div 
        className="_flex _flex-row _gap-x-1 _mt-4" 
        style={{ alignItems: 'baseline',cursor:'default' }}
        id="UnificacaoDeOrcamentos_SelecionarTodos"
      >
      {checkboxSelecionarTodos}

      {`Selecionado(s) ${props.orcamentosSelecionados.length} de ${props.totalRegistros}`}
    </div>

    const botaoGerarOrcamento = <button
        id="UnificacaoDeOrcamentos_BotaoGerarOrcamento"
      type="button" onClick={props.onProcessarUnificacaoOrcamentos} className={clsx(`no-global-button  !_bg-[#409fff] ${estiloBotoes.botaoPrimario}`)}
      disabled={props.orcamentosSelecionados?.length <= 1 || props.processandoUnificacao}
      title="Unifica os orçamentos selecionados"
    > Gerar Orçamento
    </button>

    return <form onSubmit={(e) => {
      e.preventDefault();
      formik.handleSubmit();
    }}>
      <div className={`_ml-16 _pt-8 _items-baseline ${estiloFormulario.formulario}`}>
        {campoCliente}
        {campoDataInicial}
        {campoDataFinal}
      </div>

      <div className="_flex _gap-2 _pt-2 ">
        {botaoPesquisarOrcamento}
        {botaoGerarOrcamento}
      </div>

      <>{props.listaOrcamentos?.Entities?.length > 0 &&
        <div className="_flex _gap-2 _pt-2 ">
          {botaoSelecionarTodos}
        </div>
      }</>
    </form>
  }

  const tabelaOrcamentos = () => {
    const tableHead = <div className="_table-header-group">
      <div className="_table-row">
        <div
          className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
        >
          Filial
        </div>
        <div
          className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
        >
          Data
        </div>
        <div
          className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
        >
          Orçamento
        </div>
        <div
          className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
        >
          Vendedor
        </div>
        <div
          className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
        >
          Situação
        </div>
        <div
          className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          style={{ textAlign: "right" }}
        >
          Valor Orçamento
        </div>
        <div
          className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb] text-center`}
          title="Impressão - Orçamento Finalizar - Padrão"
        >
          Visualizar
        </div>
      </div>
    </div>

    const tableBody = <div className="_table-row-group">
      {props.listaOrcamentos?.Entities?.map((value) => (
        <div
          key={value.NumeroPedido}
          className={`_table-row _cursor-pointer hover:_bg-white`}
          style={
            props.orcamentosSelecionados.some((p) => p == value.NumeroPedido)
              ? {
                backgroundColor: props.colorBackgroundSelecionada,
                color: props.colorTextoSelecionada,
              }
              : {}
          }

        >
          <div
            onClick={() => { props.onToggleOrcamentoSelecionado(value.NumeroPedido) }}
            className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
          >
            {value.CodigoFilial}
          </div>
          <div
            onClick={() => { props.onToggleOrcamentoSelecionado(value.NumeroPedido) }}
            className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
          >
            {globalMU.converterDataFormatoENParaPT(value.DataPedido)}
          </div>
          <div
            onClick={() => { props.onToggleOrcamentoSelecionado(value.NumeroPedido) }}
            className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
          >
            {value.NumeroPedido}
          </div>
          <div
            onClick={() => { props.onToggleOrcamentoSelecionado(value.NumeroPedido) }}
            className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
          >
            {value.NomeVendedor}
          </div>
          <div
            onClick={() => { props.onToggleOrcamentoSelecionado(value.NumeroPedido) }}
            className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
          >
            {value.DescricaoSituacaoVenda}
          </div>
          <div
            onClick={() => { props.onToggleOrcamentoSelecionado(value.NumeroPedido) }}
            className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
            style={{ textAlign: "right" }}
          >
            {globalMU.formatarValorNumerico(value.ValorPedido, 2, true)}
          </div>
          <div
            className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb] text-center`}
          >
            <a onClick={() => props.onConsultarOrcamento(value.NumeroPedido)} >
              <FontAwesomeIcon
                className="_text-2xl _mx-1"
                color={"#3c8ac9"}
                icon={faFileLines}
                cursor="pointer"
                title="Visualiza Orçamento"
              />
            </a>
          </div>

        </div>
      ))}
    </div>

    const paginacaoListaOrcamentos = <div className="_my-2">
      {props.listaOrcamentos?.PageCount > 1 && (
        <Paginacao
          key={props.filtro.NumeroPagina}
          paginaAtual={props.filtro.NumeroPagina}
          totalPaginas={props.listaOrcamentos.PageCount}
          id="UnificacaoDeOrcamentos_Paginacao"
          onAlterarListaSelecionada={(numeroPagina) => { props.onAlteradoPagina(numeroPagina) }}
        />
      )}
    </div>

    return <div className={`_table _w-full _border-collapse`} >
      {tableHead}
      {tableBody}
      {paginacaoListaOrcamentos}
    </div>
  }


  return (
    <>
      {formPesquisar()}
      <br />
      <>{props.listaOrcamentos?.Entities?.length > 0 &&
        tabelaOrcamentos()
      }</>
      <section style={{ marginBottom: "100px" }} />
    </>
  )
}